"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeoutError = void 0;
var tslib_1 = require("tslib");
var genericError_js_1 = require("./genericError.js");
/**
 * Ошибка таймаута. Должна использоваться, когда нужно выбросить исключение по таймауту.
 *
 * @export
 * @class TimeoutError
 * @extends {GenericError}
 */
var TimeoutError = /** @class */ (function (_super) {
    tslib_1.__extends(TimeoutError, _super);
    function TimeoutError(_a) {
        var message = _a.message, domain = _a.domain, details = _a.details;
        var _this = _super.call(this, {
            type: 'TimeoutError',
            message: message,
            domain: domain,
            details: details,
        }) || this;
        Object.setPrototypeOf(_this, TimeoutError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, TimeoutError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return TimeoutError;
}(genericError_js_1.GenericError));
exports.TimeoutError = TimeoutError;
//# sourceMappingURL=timeoutError.js.map